import { z } from 'my-zod'
import { GiftCardSchemas } from '../gift-card'

export const addGiftCardToCustomerOrderRequest = GiftCardSchemas.createGiftCardRequest
  .pick({
    recipientFirstName: true,
    recipientLastName: true,
    recipientEmail: true,
    startingBalance: true,
    unencryptedRedemptionCode: true,
    sendEmailToRecipient: true,
    senderName: true,
    expirationDate: true
  })
  .augment({
    giftCardId: z.string().uuid(),
    addonId: z.string().uuid()
  })
